<template>
  <div class="fullscreen">
    <router-view></router-view>
  </div>
</template>
<script>
export default {
  name: "fullscreen-layout"
};
</script>
<style lang="scss"></style>
